<template>
  <section>
    <!--工具条-->
    <DriverToolbar :buttonList="buttonList" @callFunction="callFunction"></DriverToolbar>

    <!--列表-->
    <el-table
      :data="drivers"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%;"
    >
      <el-table-column fixed="left" type="index" label="序号" width="60"></el-table-column>
      <el-table-column
        fixed="left"
        label="操作"
        width="80">
        <template slot-scope="scope">
          <span v-for="item in operationButtonList" :key="item.id">
            <el-button type="text" style="padding-right:6px;" size="small" v-if="!item.IsHide" @click="operationButtonFunction(item,scope.row)">{{item.name}}</el-button>
          </span>
        </template>
      </el-table-column>
      <el-table-column fixed="left" prop="OwnedCompany" label="所属公司" width="260"></el-table-column>
      <el-table-column fixed="left" prop="Name" label="司机" width="100" sortable></el-table-column>
      <el-table-column prop="Gender" label="性别" width="100" sortable></el-table-column>
      <el-table-column prop="PoliticalStatus" label="政治面貌" width="180" sortable></el-table-column>
      <el-table-column prop="HealthStatus" label="健康状态" width="150" sortable></el-table-column>
      <el-table-column prop="JobTitle" label="职称" width="150" sortable></el-table-column>
      <el-table-column prop="Education" label="文化程度" width="150" sortable></el-table-column>
      <el-table-column prop="ContactNumber" label="联系电话" width="150" sortable></el-table-column>
      <el-table-column prop="IdentificationNumber" label="身份证号码" width="200" sortable></el-table-column>
      <el-table-column prop="BirthDate" label="出生日期" :formatter="formatBirthDate"  width="150" sortable></el-table-column>
      <el-table-column prop="DriverLicenseFirstObtainingDate" label="驾驶证初领日期" :formatter="formatDriverLicenseFirstObtainingDate" width="150" sortable></el-table-column>
      <el-table-column prop="DriverLicenseValidityDate" label="驾驶证有效日期" :formatter="formatDriverLicenseValidityDate" width="150" sortable></el-table-column>
      <el-table-column prop="DriverLicenseNumber" label="驾驶证号" width="150" sortable></el-table-column>
      <el-table-column prop="WorkCertificateNumber" label="从业资格证号" width="150" sortable></el-table-column>
      <el-table-column prop="WorkCertificateScope" label="从业资格范围" width="150" sortable></el-table-column>
      <el-table-column prop="IssuingAuthority" label="发证机关" width="150" sortable></el-table-column>
      <el-table-column prop="CertificateIssuanceDate" label="从业资格证发放日" :formatter="formatCertificateIssuanceDate" width="200" sortable></el-table-column>
      <el-table-column prop="CertificateValidPeriodDate" label="从业资格证有效期" :formatter="formatCertificateValidPeriodDate" width="200" sortable></el-table-column>
      <el-table-column prop="EmploymentStatus" label="从业状态" width="150" sortable></el-table-column>
      <el-table-column prop="CreateTime" label="创建时间" :formatter="formatCreateTime" width="100" sortable></el-table-column>
      <el-table-column prop="Enabled" label="状态" width="200" sortable>
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.Enabled  ? 'success' : 'danger'"
            disable-transitions
          >{{scope.row.Enabled ? "正常":"禁用"}}</el-tag>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="total, sizes, prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-sizes="[10, 15, 20, 50, 100, 200]"
        :total="total"
        style="float:right;"
      ></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
        <el-row>
          <el-col :span="10">
            <el-form-item label="所属公司" prop="CompanyId" label-width="110px">
              <el-select style="width: 100%;" v-model="editForm.CompanyId" placeholder="请选择所属公司">
                <el-option
                  v-for="item in companys"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.CompanyName"
                >
                  <span style="float: left">{{ item.CompanyName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="状态" prop="Enabled" label-width="110px">
              <el-select v-model="editForm.Enabled" placeholder="请选择人员状态">
                <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="司机姓名" prop="Name" label-width="110px">
              <el-input v-model="editForm.Name" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="性别" prop="Gender" label-width="110px">
              <el-select v-model="editForm.Gender" placeholder="请选择性别">
                <el-option
                  v-for="item in genderList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="身份证号码" prop="IdentificationNumber" label-width="110px">
              <el-input v-model="editForm.IdentificationNumber" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="出生日期" prop="BirthDate" label-width="110px">
              <el-date-picker v-model="editForm.BirthDate" type="date" placeholder="选择出生日期" value-format="yyyy-MM-dd" style="width:183px;"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="联系电话" prop="ContactNumber" label-width="110px">
              <el-input v-number-only v-model="editForm.ContactNumber" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="文化程度" prop="Education" label-width="110px">
              <el-select v-model="editForm.Education" clearable placeholder="请选择文化程度">
                <el-option
                  v-for="item in educationList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="政治面貌" prop="PoliticalStatus" label-width="110px">
              <el-select v-model="editForm.PoliticalStatus" clearable placeholder="请选择政治面貌">
                <el-option
                  v-for="item in politicalStatusList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="健康状态" prop="HealthStatus" label-width="110px">
              <el-select v-model="editForm.HealthStatus" clearable placeholder="请选择健康状态">
                <el-option
                  v-for="item in healthStatusList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="职称" prop="JobTitle" label-width="110px">
              <el-input v-model="editForm.JobTitle" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="驾驶证初领日期" prop="DriverLicenseFirstObtainingDate" label-width="110px">
              <el-date-picker v-model="editForm.DriverLicenseFirstObtainingDate" type="date" placeholder="选择驾驶证初领日期" value-format="yyyy-MM-dd" style="width:183px;"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="驾驶证有效日期" prop="DriverLicenseValidityDate" label-width="110px">
              <el-date-picker v-model="editForm.DriverLicenseValidityDate" type="date" placeholder="选择驾驶证有效日期" value-format="yyyy-MM-dd" style="width:183px;"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="驾驶证号" prop="DriverLicenseNumber" label-width="110px">
              <el-input v-model="editForm.DriverLicenseNumber" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="从业证发放日" prop="CertificateIssuanceDate" label-width="110px">
              <el-date-picker v-model="editForm.CertificateIssuanceDate" type="date" placeholder="选择从业资格证发放日" value-format="yyyy-MM-dd" style="width:183px;"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="从业证有效期" prop="CertificateValidPeriodDate" label-width="110px">
              <el-date-picker v-model="editForm.CertificateValidPeriodDate" type="date" placeholder="选择从业资格证有效期" value-format="yyyy-MM-dd" style="width:183px;"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="从业资格证号" prop="WorkCertificateNumber" label-width="110px">
              <el-input v-model="editForm.WorkCertificateNumber" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="从业状态" prop="EmploymentStatus" label-width="110px">
              <el-select v-model="editForm.EmploymentStatus" clearable placeholder="请选择从业状态">
                <el-option
                  v-for="item in employmentStatusList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
           <el-form-item label="从业资格范围" prop="WorkCertificateScope" label-width="110px">
              <el-input v-model="editForm.WorkCertificateScope" />
            </el-form-item>
        </el-row>
        <el-row>
           <el-form-item label="发证机关" prop="IssuingAuthority" label-width="110px">
              <el-input v-model="editForm.IssuingAuthority" />
            </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
        <el-row>
          <el-col :span="10">
            <el-form-item label="所属公司" prop="CompanyId" label-width="110px">
              <el-select style="width: 100%;" v-model="addForm.CompanyId" placeholder="请选择所属公司">
                <el-option
                  v-for="item in companys"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.CompanyName"
                >
                  <span style="float: left">{{ item.CompanyName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="状态" prop="Enabled" label-width="110px">
              <el-select v-model="addForm.Enabled" placeholder="请选择车辆状态">
                <el-option label="激活" value="true"></el-option>
                <el-option label="禁用" value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="司机姓名" prop="Name" label-width="110px">
              <el-input v-model="addForm.Name" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="性别" prop="Gender" label-width="110px">
              <el-select v-model="addForm.Gender" placeholder="请选择性别">
                <el-option
                  v-for="item in genderList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="身份证号码" prop="IdentificationNumber" label-width="110px">
              <el-input v-model="addForm.IdentificationNumber" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="出生日期" prop="BirthDate" label-width="110px">
              <el-date-picker v-model="addForm.BirthDate" type="date" placeholder="选择出生日期" value-format="yyyy-MM-dd" style="width:183px;"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="联系电话" prop="ContactNumber" label-width="110px">
              <el-input v-number-only v-model="addForm.ContactNumber" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="文化程度" prop="Education" label-width="110px">
              <el-select v-model="addForm.Education" clearable placeholder="请选择文化程度">
                <el-option
                  v-for="item in educationList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="政治面貌" prop="PoliticalStatus" label-width="110px">
              <el-select v-model="addForm.PoliticalStatus" clearable placeholder="请选择政治面貌">
                <el-option
                  v-for="item in politicalStatusList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="健康状态" prop="HealthStatus" label-width="110px">
              <el-select v-model="addForm.HealthStatus" clearable placeholder="请选择健康状态">
                <el-option
                  v-for="item in healthStatusList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="职称" prop="JobTitle" label-width="110px">
              <el-input v-model="addForm.JobTitle" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="驾驶证初领日期" prop="DriverLicenseFirstObtainingDate" label-width="110px">
              <el-date-picker v-model="addForm.DriverLicenseFirstObtainingDate" type="date" placeholder="选择驾驶证初领日期" value-format="yyyy-MM-dd" style="width:183px;"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="驾驶证有效日期" prop="DriverLicenseValidityDate" label-width="110px">
              <el-date-picker v-model="addForm.DriverLicenseValidityDate" type="date" placeholder="选择驾驶证有效日期" value-format="yyyy-MM-dd" style="width:183px;"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="驾驶证号" prop="DriverLicenseNumber" label-width="110px">
              <el-input v-model="addForm.DriverLicenseNumber" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="从业证发放日" prop="CertificateIssuanceDate" label-width="110px">
              <el-date-picker v-model="addForm.CertificateIssuanceDate" type="date" placeholder="选择从业资格证发放日" value-format="yyyy-MM-dd" style="width:183px;"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="从业证有效期" prop="CertificateValidPeriodDate" label-width="110px">
              <el-date-picker v-model="addForm.CertificateValidPeriodDate" type="date" placeholder="选择从业资格证有效期" value-format="yyyy-MM-dd" style="width:183px;"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="从业资格证号" prop="WorkCertificateNumber" label-width="110px">
              <el-input v-model="addForm.WorkCertificateNumber" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="从业状态" prop="EmploymentStatus" label-width="110px">
              <el-select v-model="addForm.EmploymentStatus" clearable placeholder="请选择从业状态">
                <el-option
                  v-for="item in employmentStatusList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
           <el-form-item label="从业资格范围" prop="WorkCertificateScope" label-width="110px">
              <el-input v-model="addForm.WorkCertificateScope" />
            </el-form-item>
        </el-row>
        <el-row>
           <el-form-item label="发证机关" prop="IssuingAuthority" label-width="110px">
              <el-input v-model="addForm.IssuingAuthority" />
            </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--操作日记-->
    <el-dialog
      title="操作日记"
      :visible.sync="operateDataLogFormVisible"
      v-model="operateDataLogFormVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="60%"
    >
      <OperateDataLog v-if="operateDataLogFormVisible" :entityName="entityName" :entityKey="entityKey"></OperateDataLog>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="operateDataLogFormVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import { getDriverListPage, removeDriver, editDriver, addDriver, getCompanyListPage } from "../../api/api";
import { getButtonList,getOperationButtonList } from "../../promissionRouter";
import DriverToolbar from "../../components/QueryToolbar/DriverToolbar";
import OperateDataLog from "../../components/OperateDataLog";

export default {
  components: { DriverToolbar,OperateDataLog },
  data() {
    return {
      filters: {
        companyId: "",
        driverName: "",
        employmentStatus: ""
      },
      entityName: 'Driver', //操作日记中的表名称
      entityKey: '',  //操作日记中的表的Id
      buttonList: [],
      operationButtonList: [],
      drivers: [], //司机列表
      companys: [], //企业列表
      statusList: [
        { name: "激活", value: true },
        { name: "禁用", value: false }
      ],
      genderList: [
        { name: "男", value: "男" },
        { name: "女", value: "女" }
      ],
      politicalStatusList: [
        { name: "中共党员", value: "中共党员" },
        { name: "中共预备党员", value: "中共预备党员" },
        { name: "共青团员", value: "共青团员" }
      ],
      healthStatusList: [
        { name: "健康", value: "健康" },
        { name: "一般", value: "一般" },
        { name: "较差", value: "较差" }
      ],
      educationList: [
        { name: "研究生", value: "研究生" },
        { name: "大学本科", value: "大学本科" },
        { name: "专科", value: "专科" },
        { name: "技校", value: "技校" },
        { name: "高中", value: "高中" },
        { name: "初中", value: "初中" },
        { name: "小学", value: "小学" }
      ],
      employmentStatusList: [
        { name: "在职", value: "在职" },
        { name: "离职", value: "离职" }
      ],
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      operateDataLogFormVisible: false, //查看操作日记界面是否显示
      editLoading: false,
      editFormRules: {
        CompanyId: [{ required: true, message: "请输入所属公司", trigger: "blur" }],
        Enabled: [{ required: true, message: "请选择状态", trigger: "blur" }],
        Name: [{ required: true, message: "请输入司机姓名", trigger: "blur" }],
        Gender: [{ required: true, message: "请输入性别", trigger: "blur" }]
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        CreateBy: "",
        CompanyId: 0,
        Enabled: false,
        Name: "",
        Gender: "",
        PoliticalStatus: "",
        HealthStatus: "",
        JobTitle: "",
        Education: "",
        ContactNumber: "",
        IdentificationNumber: "",
        BirthDate: null,
        DriverLicenseFirstObtainingDate: null,
        DriverLicenseValidityDate: null,
        DriverLicenseNumber: "",
        WorkCertificateNumber: "",
        WorkCertificateScope: "",
        IssuingAuthority: "",
        CertificateIssuanceDate: null,
        CertificateValidPeriodDate: null,
        EmploymentStatus: ""
      },
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        CompanyId: [{ required: true, message: "请输入所属公司", trigger: "blur" }],
        Enabled: [{ required: true, message: "请选择状态", trigger: "blur" }],
        Name: [{ required: true, message: "请输入司机姓名", trigger: "blur" }],
        Gender: [{ required: true, message: "请输入性别", trigger: "blur" }]
      },
      //新增界面数据
      addForm: {
        CreateBy: "",
        CreateId: "",
        CompanyId: 0,
        Enabled: "true",
        Name: "",
        Gender: "",
        PoliticalStatus: "",
        HealthStatus: "",
        JobTitle: "",
        Education: "",
        ContactNumber: "",
        IdentificationNumber: "",
        BirthDate: null,
        DriverLicenseFirstObtainingDate: null,
        DriverLicenseValidityDate: null,
        DriverLicenseNumber: "",
        WorkCertificateNumber: "",
        WorkCertificateScope: "",
        IssuingAuthority: "",
        CertificateIssuanceDate: null,
        CertificateValidPeriodDate: null,
        EmploymentStatus: ""
      }
    };
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        companyId: item.companyId,
        driverName: item.driverName,
        employmentStatus: item.employmentStatus
      };
      this[item.Func].apply(this, item);
    },
    operationButtonFunction(item,row){
      this.currentRow = row;
      this[item.Func].apply(this,item);
    },
    //性别显示转换
    formatEnabled: function(row, column) {
      return row.Enabled ? "正常" : "未知";
    },
    formatBirthDate: function(row, column) {
      return !row.BirthDate || row.BirthDate == ""
        ? ""
        : util.formatDate.format(new Date(row.BirthDate), "yyyy-MM-dd");
    },
    formatCreateTime: function(row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd");
    },
    formatDriverLicenseFirstObtainingDate: function(row, column) {
      return !row.DriverLicenseFirstObtainingDate || row.DriverLicenseFirstObtainingDate == ""
        ? ""
        : util.formatDate.format(new Date(row.DriverLicenseFirstObtainingDate), "yyyy-MM-dd");
    },
    formatDriverLicenseValidityDate: function(row, column) {
      return !row.DriverLicenseValidityDate || row.DriverLicenseValidityDate == ""
        ? ""
        : util.formatDate.format(new Date(row.DriverLicenseValidityDate), "yyyy-MM-dd");
    },
    formatCertificateIssuanceDate: function(row, column) {
      return !row.CertificateIssuanceDate || row.CertificateIssuanceDate == ""
        ? ""
        : util.formatDate.format(new Date(row.CertificateIssuanceDate), "yyyy-MM-dd");
    },
    formatCertificateValidPeriodDate: function(row, column) {
      return !row.CertificateValidPeriodDate || row.CertificateValidPeriodDate == ""
        ? ""
        : util.formatDate.format(new Date(row.CertificateValidPeriodDate), "yyyy-MM-dd");
    },
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.getDriver();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getDriver();
    },
    queryDriver(){
      this.page = 1;
      this.getDriver();
    },
    //获取人员列表
    getDriver() {
      let _this = this;
      let para = {
        companyId: _this.filters.companyId,
        driverName: _this.filters.driverName,
        employmentStatus: _this.filters.employmentStatus,
        page: _this.page,
        pageSize: _this.pageSize,
      };
      _this.listLoading = true;
      getDriverListPage(para).then(res => {
        _this.total = res.data.response.dataCount;
        _this.drivers = res.data.response.data;
        _this.listLoading = false;
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning"
      })
      .then(() => {
        this.listLoading = true;
        let para = { id: row.Id };
        removeDriver(para).then(res => {
          if (util.isEmt.format(res)) {
            this.listLoading = false;
            return;
          }
          this.listLoading = false;
          if (res.data.success) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "error"
            });
          }

          this.getDriver();
        });
      })
      .catch(() => {});
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });

        return;
      }

      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        CreateBy: "",
        CompanyName: "",
        Enabled: "true",
        HealthStatus: "健康",
        EmploymentStatus: "在职"
      };
    },
    //查看操作日记
    lookUpOperateDataLog() {
      this.operateDataLogFormVisible = true;
      this.entityKey = this.currentRow.Id;
    },
    //编辑
    editSubmit: function() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);

            para.birth =
              !para.birth || para.birth == ""
                ? util.formatDate.format(new Date(), "yyyy-MM-dd")
                : util.formatDate.format(new Date(para.birth), "yyyy-MM-dd");

            editDriver(para).then(res => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }

              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.getDriver();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function() {
      let _this = this;
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let para = Object.assign({}, this.addForm);
            para.birth =
              !para.birth || para.birth == ""
                ? util.formatDate.format(new Date(), "yyyy-MM-dd")
                : util.formatDate.format(new Date(para.birth), "yyyy-MM-dd");

            var user = JSON.parse(window.localStorage.user);

            if (user && user.uID > 0) {
              para.CreateId = user.uID;
              para.CreateBy = user.uRealName;
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error"
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            addDriver(para).then(res => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              if (res.data.success) {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getDriver();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    selsChange: function(sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function() {
      this.$message({
        message: "该功能未开放",
        type: "warning"
      });
    },
    getButtonList2(routers) {
      let _this = this;
      routers.forEach(element => {
        let path = this.$route.path.toLowerCase();
        if (element.path && element.path.toLowerCase() == path) {
          _this.buttonList = element.children;
          return;
        } else if (element.children) {
          _this.getButtonList(element.children);
        }
      });
    }
  },
  mounted() {
    this.getDriver();

    getCompanyListPage().then(res => {
      this.companys = res.data.response.data;
    });

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);
    
    //第二种写法，封装到 permissionRouter.js 中
    this.buttonList = getButtonList(this.$route.path, routers);
    this.operationButtonList = getOperationButtonList(this.$route.path, routers);
  }
}
</script>

<style scoped>

</style>
